import { jsx as i } from "react/jsx-runtime";
import { forwardRef as m, useContext as d, useMemo as u, useEffect as p } from "react";
import { Flex as g } from "../../flex/flex.js";
import { ChartContext as x, useValues as C } from "./chart-utils.js";
import f from "../chart.module.css.js";
import c from "clsx/lite";
const R = m(
  function({ className: e, ...r }, s) {
    const { setLegends: t } = d(x) || {}, [a, l] = C(s), n = u(() => v(a).join(","), [a]);
    return p(() => {
      n && (t == null || t(n.split(",")));
    }, [n, t]), /* @__PURE__ */ i(
      g,
      {
        align: "center",
        className: c(f.legends, e),
        gap: "xs sm",
        justify: "center",
        ref: l,
        ...r
      }
    );
  }
), E = m(
  function({ className: e, ...r }, s) {
    return /* @__PURE__ */ i(
      "div",
      {
        className: c(f.legend, e),
        "data-value": "legend",
        ref: s,
        ...r
      }
    );
  }
);
let h = Date.now();
const v = (o) => o.map(({ el: e }) => e.id || (e.id = (++h).toString(32)));
export {
  E as ChartLegend,
  R as ChartLegends
};
//# sourceMappingURL=chart-legends.js.map
